import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

import IMAGE from "../../../assets/images/bg_1.jpg";

export const Map = () => {
  const position = [27.047596, 87.2912496];
  return (
    <div className="map-container">
      <div className="map">
        <div className="map-leaflet">
          <MapContainer center={position} zoom={13} scrollWheelZoom={false}>
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position}>
              <Popup>
                ARSP Office <br />
                <img
                  src={IMAGE}
                  width={250}
                  style={{ borderRadius: 4, marginTop: 10 }}
                />
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default Map;
